import React, { useEffect,useState } from 'react';
import Data from '../../constants.json';
import PropTypes from 'prop-types';
import { useNavigate, NavLink } from 'react-router-dom';
import { NullUndefinedCheck } from '../../genericFunctions/nullUndefinedCheck';


const NavItems = ({ navItems }) => {
  const navigate = useNavigate();
  const [navList, setNavList] = useState(null);
  const handleRoute = (path) => {
    navigate(path);
  };
  const linkStyle = { color: '#ff3333' };
 
  useEffect(() => {
    const routeAccessData = !NullUndefinedCheck(sessionStorage.getItem('routeAccessData')) ? JSON.parse(sessionStorage.getItem('routeAccessData')) : null
    if(navList == null && routeAccessData){
      const navListUpdated = navItems.filter((item) => {
        if(routeAccessData?.includes(item.name + ' Page')) return true;
      })
      setNavList(navListUpdated)
    }
  }, [navList])


  return (
    <>
      {navList && navList.map(({ name, id, path }) => {
        return (
          <NavLink key={id} data-testid={`nav-${path}`} to={path} onClick={() => handleRoute(path)} activestyle={linkStyle}>{`${name}`}</NavLink>
        );
      })}
    </>
  );
};


const NavBar = () => {
  const { navItems } = { ...Data };

  return (
    <se-tabbar>
      <nav data-testid='nav'>
        <NavItems navItems={navItems} />
      </nav>
    </se-tabbar>
  );
};
export default NavBar;

NavBar.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }).isRequired,
  ),
};
